import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { range } from '../../util/range.js';
import { Badge as BadgeMemoized } from '../Badge/Badge.js';
import { Box } from '../Box/Box.js';
import { Icon } from '../Icon/Icon.js';
import { ScreenReaderOnly } from '../ScreenReaderOnly/ScreenReaderOnly.js';
import { useDirectionContext } from '../../contexts/session/Locale.js';

var _excluded = ["variant", "score", "label", "size", "color"];
var colorToken = {
  hotel: 'product.rating-hotels',
  nha: 'product.rating-homes'
};
var iconToken = {
  star: 'fill.symbol.star',
  circle: 'fill.symbol.circle',
  diamond: 'fill.symbol.diamond'
};
var iconHalfToken = {
  star: 'fill.symbol.star-half',
  circle: 'fill.symbol.circle-half',
  diamond: 'fill.symbol.diamond-half'
};
var sizeToken = {
  s: '12',
  m: '14'
};
var HALF_RATING = 0.5;
var MAX_RATING = 5;

/** Rating visualizes a score as a sequence of stars, circles or a textual representation. */
var Rating = function Rating(_ref) {
  var variant = _ref.variant,
    score = _ref.score,
    scoreText = _ref.label,
    size = _ref.size,
    color = _ref.color,
    rest = _objectWithoutProperties(_ref, _excluded);
  var direction = useDirectionContext();
  if (score < HALF_RATING || score > MAX_RATING) {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  var computedColor = colorToken[color];
  var textColor = computedColor;
  if (variant === 'badge') {
    if (!scoreText) return null;
    var badgeVariant = computedColor === 'product.rating-hotels' ? 'tertiary.rating-hotel' : 'tertiary.rating-nha';
    return /*#__PURE__*/React.createElement(BadgeMemoized, _extends({
      label: scoreText,
      variant: badgeVariant
    }, rest));
  }
  var fullCount = Math.floor(score);
  var hasHalf = score - fullCount >= HALF_RATING;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  var iconSize = sizeToken[size];
  var iconId = iconToken[variant];
  var iconHalfId = iconHalfToken[variant];
  var halfIcon = hasHalf ? [/*#__PURE__*/React.createElement(Icon, {
    id: iconHalfId,
    color: textColor,
    size: iconSize,
    direction: direction,
    key: iconHalfId
  })] : [];
  var icons = range(fullCount).map(function (i) {
    return /*#__PURE__*/React.createElement(Icon, {
      id: iconId,
      color: textColor,
      size: iconSize,
      direction: direction,
      key: "".concat(iconId, "-").concat(i)
    });
  }).concat(halfIcon);
  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "flex"
  }, rest), /*#__PURE__*/React.createElement(ScreenReaderOnly, null, scoreText), icons);
};
Rating.displayName = 'Rating';
Rating.defaultProps = {
  size: 'm',
  color: 'hotel'
};

export { Rating };
//# sourceMappingURL=Rating.js.map
